const constants       = require('wp-constants').spacerFree;
const {
  questionUnitMap,
  quizOrderInfo
}                     = require('wp-data');
const _               = require('lodash');

function getQuestionUnit(questionIndex) {
  return questionUnitMap.getQuestionUnitById(quizOrderInfo.quizOrder[questionIndex]);
}

function isRankQuestion(questionUnit) {
  return questionUnit.answerType === constants.questionUnit.PROFILE_ANSWER_TYPE.RANK;
}

function isGroupedQuestion(questionUnit) {
  return quizOrderInfo.groupedQuestions.indexOf(questionUnit.id) > -1;
}

function isQuestionAnswerComplete(questionIndex, questionAnswer) {
  const questionUnit = getQuestionUnit(questionIndex);
  return isRankQuestion(questionUnit) ? questionAnswer.indexOf(null) === -1 : !!questionAnswer;
}

function getInitialAnswer(questionUnit) {
  if (!isRankQuestion(questionUnit)) return '';
  const answer = [];
  for (let i = 0, len = questionUnit.points.length; i < len; i += 1) {
    answer.push(null);
  }
  return answer;
}

function hasQuestionResponse(questionUnit) {
  return !!(questionUnit.response || (questionUnit.options && _.find(questionUnit.options, 'response')));
}

function getQuestionResponse(questionUnit, selectedOption) {
  if (questionUnit.response) {
    return {
      text: questionUnit.response,
      illustrationName: questionUnit.responseIllustrationName
    };
  }
  if (questionUnit.options && questionUnit.options[selectedOption]) {
    return {
      text: questionUnit.options[selectedOption].response,
      illustrationName: questionUnit.options[selectedOption].responseIllustrationName
    };
  }
  return {};
}

function getAllResponseIllustrationNames(questionUnit) {
  if (questionUnit.responseIllustrationName) return [questionUnit.responseIllustrationName];
  const illustrationNames = [];
  if (questionUnit.options) {
    Object.keys(questionUnit.options).forEach((option) => {
      const responseIllustrationName = questionUnit.options[option].responseIllustrationName;
      // sometimes, two responses have the same illustration, don't double up
      if (responseIllustrationName && !_.includes(illustrationNames, responseIllustrationName)) {
        illustrationNames.push(responseIllustrationName);
      }
    });
  }
  return illustrationNames;
}

function tokenizeAnswerText(questionUnits, t) {
  const answerText = questionUnits.answerText;

  if (isRankQuestion(questionUnits)) {
    Object.keys(answerText).forEach((id) => {
      answerText[id][0] = t(answerText[id][0]);
    });
  } else {
    Object.keys(answerText).forEach((idx) => {
      if (answerText[idx] !== '[INPUT]') {
        answerText[idx] = t(answerText[idx]);
      }
    });
  }
}

function tokenizeOptionsText(options, t) {
  Object.keys(options).forEach((optionId) => {
    options[optionId].text = t(options[optionId].text);
  });
}

function tokenizePlaceholderText(questionUnit, t) {
  questionUnit.emptyAnswerPlaceholder = t(questionUnit.emptyAnswerPlaceholder);
}

function tokenizeHelperText(questionUnit, t) {
  questionUnit.answerHelperText = t(questionUnit.answerHelperText);
}

function tokenizeResponseText(questionUnit, t) {
  if (questionUnit.response) {
    questionUnit.response = t(questionUnit.response);
  } else {
    const options = questionUnit.options;
    Object.keys(options).forEach((optionId) => {
      options[optionId].response = t(options[optionId].response);
    });
  }
}

function tokenizeQuestionUnit(questionUnit, t) {
  const tokenizedQuestionUnit = _.cloneDeep(questionUnit);

  if (tokenizedQuestionUnit.answerText) {
    tokenizeAnswerText(tokenizedQuestionUnit, t);
  }
  if (tokenizedQuestionUnit.options) {
    tokenizeOptionsText(tokenizedQuestionUnit.options, t);
  }
  if (tokenizedQuestionUnit.emptyAnswerPlaceholder) {
    tokenizePlaceholderText(tokenizedQuestionUnit, t);
  }
  if (tokenizedQuestionUnit.answerHelperText) {
    tokenizeHelperText(tokenizedQuestionUnit, t);
  }
  if (this.hasQuestionResponse(tokenizedQuestionUnit)) {
    tokenizeResponseText(tokenizedQuestionUnit, t);
  }

  return tokenizedQuestionUnit;
}

module.exports = {
  getQuestionUnit,
  isRankQuestion,
  isGroupedQuestion,
  isQuestionAnswerComplete,
  getInitialAnswer,
  hasQuestionResponse,
  getQuestionResponse,
  getAllResponseIllustrationNames,
  tokenizeQuestionUnit
};
